/* eslint-disable max-len */
import baseApi from './baseApi';
import startupConfig from '../config/startupConfig';

const apiPath = 'api/';

const get = (urlPart) => {
  const config = startupConfig.get();
  const baseUrl = config ? config.registrationServiceUrl || '' : '';
  return baseApi.get(`${baseUrl}/${apiPath}${urlPart}`);
};

const post = (urlPart, data) => {
  const config = startupConfig.get();
  const baseUrl = config ? config.registrationServiceUrl || '' : '';
  return baseApi.post(`${baseUrl}/${apiPath}${urlPart}`, data);
};

const patch = (urlPart, data) => {
  const config = startupConfig.get();
  const baseUrl = config ? config.registrationServiceUrl || '' : '';
  return baseApi.patch(`${baseUrl}/${apiPath}${urlPart}`, data);
};

const upload = (urlPart, file, suppressAnalyticsEvent = false) => {
  const config = startupConfig.get();
  const baseUrl = config ? config.registrationServiceUrl || '' : '';
  return baseApi.upload(`${baseUrl}/${apiPath}${urlPart}`, file, suppressAnalyticsEvent);
};

const deleteRequest = (urlPart) => {
  const config = startupConfig.get();
  const baseUrl = config ? config.registrationServiceUrl || '' : '';
  return baseApi.deleteRequest(`${baseUrl}/${apiPath}${urlPart}`);
};

const getStartupConfig = () => get('configuration/startup');

const checkEligibility = (id, isTrustee, portal, registrationMode) =>
  get(
    `${id}/validate?isTrustee=${isTrustee === true}&portal=${portal}&registrationMode=${registrationMode || ''}`,
  );

const searchTrust = (keyword) => get(`trusts/${keyword}`);

const validateRelatedEntity = (abn, relatedEntityId, portal, registrationMode) =>
  get(
    `${abn}/relatedentity/${relatedEntityId}/validate?portal=${portal}&registrationMode=${registrationMode}`,
  );

const uploadDeed = (abn, data) => post(`${abn}/uploaddeed`, data);

const saveTrustDetails = (abn, data) => post(`${abn}/relatedentity`, data);

const searchCompany = (keyword) => get(`companies/${keyword}`);

const verifyMobileNumber = (href, mobileNumber, portal) => {
  const hrefFilled = href.replace('{mobile}', mobileNumber).replace('{portal}', portal);
  return get(hrefFilled);
};

const confirmMobileNumber = (href, mobileNumber, pin, marketingTags) =>
  post(href, { ...marketingTags, mobile: mobileNumber, pin });

const searchAddress = (keyword) => get(`addresses/${encodeURIComponent(keyword)}`);

const getSupportingDocs = () => get('supportingdocs');

const verifyId = (href, data) => post(href, data);

const verifyIdPrefilled = (abn, data) => post(`${abn}/verifyid/prefilled`, data);

const verifyInvite = (invitationCode, inviterRole, portal, recipientGcContactId) =>
  get(
    `invitation/verify?invitationCode=${invitationCode}&inviterRole=${inviterRole}&portal=${portal}&recipientGcContactId=${recipientGcContactId}`,
  );

const register = (href, data) => post(href, data);

const saveMobileNumberNoVerify = (href, mobileNumber) => post(href, { mobile: mobileNumber });

const createLead = (href, data) => post(href, data);

const sendBanklinkSms = (href) => post(href);

const createAccountByABN = (abn, data) => post(`accounts/abn/${abn}`, data);

const createDocument = (gcAccountId, data) => post(`Documents/${gcAccountId}`, data);

const updateDocumentStatus = (data) => post('Documents/updateDocumentStatus', data);

const getLatestDocumentsPerType = (sfContactId, getCapitalAccountId) =>
  get(`Documents/getLatestDocumentsPerType/${sfContactId}/${getCapitalAccountId}`);

const uploadDocumentFile = (gcAccountId, documentId, file, suppressAnalyticsEvent = false) =>
  upload(`Documents/upload/${gcAccountId}/${documentId}`, file, suppressAnalyticsEvent);

const deleteDocumentFile = (gcAccountId, documentId) =>
  deleteRequest(`Documents/file/${gcAccountId}/${documentId}`);

const raiseAnalyticsEventKYCFail = (gcAccountId, data) =>
  post(`Analytics/${gcAccountId}/KYCFail`, data);

const ssoExistingContact = (abn, data) => post(`${abn}/sso-existing-contact`, data);

const ssoContactPrefilledId = (abn, data) => post(`${abn}/sso-contact/prefilled-id`, data);

const verifySso = (request) =>
  get(
    `${request.gcAccountId}/contact-sso-verify?firstName=${request.firstName}&lastName=${request.lastName}&mobile=${request.mobileNumber}&dob=${request.dateOfBirth}`,
  );

const updateRegistrationAttemptCase = (data) => patch('cases/registration-attempt', data);

export default {
  checkEligibility,
  searchTrust,
  validateRelatedEntity,
  saveTrustDetails,
  searchCompany,
  verifyMobileNumber,
  confirmMobileNumber,
  searchAddress,
  getSupportingDocs,
  verifyId,
  verifyIdPrefilled,
  register,
  createLead,
  uploadDeed,
  verifyInvite,
  sendBanklinkSms,
  getStartupConfig,
  saveMobileNumberNoVerify,
  createAccountByABN,
  createDocument,
  uploadDocumentFile,
  deleteDocumentFile,
  raiseAnalyticsEventKYCFail,
  ssoExistingContact,
  verifySso,
  updateRegistrationAttemptCase,
  ssoContactPrefilledId,
  getLatestDocumentsPerType,
  updateDocumentStatus,
};
